<div class="workspace influencer-page">
  <div class="infl-container">
    <div class="basic-info-container">
      <div class="row basic-info">
        <div class="col-sm-2 back-button-container">
          <div class="back-btn d-flex justify-content-center align-items-center" *ngIf="!hiddenBackButton" (click)="back()" >
            <svg width="8px" height="20px" viewBox="0 0 19 41" version="1.1" xmlns="http://www.w3.org/2000/svg">
              <defs></defs>
              <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="Arrow/Left" transform="translate(-12.000000, -4.000000)" fill="#000000">
                  <path d="M28.949609,44.5859918 L12,24.4995264 L28.949609,4.41407071 C29.3745432,3.90817291 30.1162287,3.86071343 30.6006146,4.29996602 C31.0869498,4.74022838 31.1356807,5.50563864 30.7107466,6.00951689 L15.1061126,24.4995264 L30.7107466,42.9905456 C31.1356807,43.4944239 31.0869498,44.2598341 30.6006146,44.6990867 C30.3784013,44.9000322 30.1045332,45 29.8306651,45 C29.5051422,45 29.1815685,44.8596411 28.949609,44.5859918 Z" id="Fill-1"></path>
                </g>
              </g>
            </svg>
          </div>
        </div>
        <div class="col-sm-10 influencer-basic-info-container">
          <div class="influencer-basic-info">
            <achoo-placeholder [facebookPlaceholder]="true"
                              [normalPlaceholder]="false"
                              [placeholderId]="'influencerBasicInformation'">
              <app-influencer-basic-information
                [influencer]="influencer"
                [supportIgStoryLoader]="true"
                [showCountryFlagIcon]="showCountryFlagIcon">
              </app-influencer-basic-information>
            </achoo-placeholder>
          </div>
          <div class="influencer-note-list" *ngIf="influencer">
            <add-notes [influencerId]="influencer.id" [isReadOnly]="isArchivedCampaign"></add-notes>
          </div>
        </div>
      </div>
    </div>
    <div class="main-infl-content" *ngIf="influencer">
      <div class="tab-container">
        <ul class="nav nav-tabs" id="myTab" [ngStyle]="{backgroundColor: platformBackground}" role="tablist">
          <li class="nav-item">
            <a class="nav-link" [ngClass]="{'active': isActiveOverviewTab}"
               data-toggle="tab" (click)="showOverview();" role="tab"
               placement="bottom"
               ngbTooltip="{{'info_box.influencer.overview' | translate}}">{{ 'INFLUENCER.OVERVIEW' | translate }}</a>
          </li>
          <li class="nav-item insight-tab">
            <a class="nav-link" [ngClass]="{'active': isActiveInsightTab}"
               data-toggle="tab" (click)="showInsight()"
               role="tab" placement="bottom"
               ngbTooltip="{{'info_box.influencer.insight' | translate}}">{{ 'INFLUENCER.ACTIVITY' | translate }}</a>
          </li>
          <li class="nav-item demographic-tab">
            <a class="nav-link" [ngClass]="{'active': isActiveDemographicTab}"
               data-toggle="tab" (click)="showDemographics()"
               role="tab" placement="bottom"
               ngbTooltip="{{'info_box.influencer.demographic' | translate}}">{{ 'INFLUENCER.DEMOGRAPHICS' | translate }}</a>
          </li>
          <li *ngIf="!isDisableActivityTab" class="nav-item activity-tab">
            <a class="nav-link" [ngClass]="{'active': isActiveActivityTab}"
               data-toggle="tab"
               actionByLevels="Direct Communication"
               [wallName]="'Influencer Profile Disabled'"
               (afterChecking)="showActivity()"
               role="tab">{{ 'INFLUENCER.ACTIVITY_CONTACT' | translate }}</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" [ngClass]="{'active': isActiveCampaignTab}"
               data-toggle="tab"
               actionByLevels="Add to Campaign"
               [actionData]="campaignActionData"
               [wallName]="'Campaigns Disabled'"
               (afterChecking)="showCampaign()"
               role="tab" placement="bottom"
               ngbTooltip="{{'info_box.influencer.campaign' | translate}}">{{ 'INFLUENCER.CAMPAIGN' | translate }}</a>
          </li>
        </ul>
        <div class="tab-content" >
          <app-influencer-overview *ngIf="isActiveOverviewTab"
                                   [influencerId]="influencerId"
                                   [groupId]="groupId">
          </app-influencer-overview>
          <influencer-insight *ngIf="isActiveInsightTab"
                              [influencerId]="influencerId"
                              [channelFollowerParams]="channelFollowerParam"
                              (changeActiveChannel)="changeChannel($event)">
          </influencer-insight>
          <demographic-page #InfluencerDemographic *ngIf="isActiveDemographicTab"
                            [target]="target"
                            [demoInfluencerId]="influencerId"
                            [selectedChannel]="demographicChannelParam"
                            (changeDemographicSourceEvent)="changeDemographicSource($event)">
          </demographic-page>
          <influencer-campaign-activity #InfluencerCampaignActivity
                                        *ngIf="isActiveCampaignTab"
                                        [isReadOnly]="true"
                                        [influencerId]="influencerId"
                                        [campaignInfluencerId]="campaignInfluencerId"
                                        [fromPath]="fromPath"
                                        [campaignId]="selectedCampaignId"
                                        (selectPostToDeleteFromCampaign)="onSelectPostToDelete($event)"
                                        (selectedInfluencerCampaignChanged)="onSelectedInfluencerCampaignChanged($event)">
          </influencer-campaign-activity>
          <div class="chat-container" *ngIf="isActiveActivityTab && influencerConversation && !isDisableActivityTab">
            <influencer-chat [conversation]="influencerConversation"
                             [influencerId]="influencerId"
                             [showActivityLog]="showActivityLog"></influencer-chat>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="bottombar"
    [ngClass]="{'open': activeBottomBar === true, 'collapsed': activeBottomBar === false}">
  <div class="row full-height" *ngIf="!isActiveCampaignTab">
    <div class="col-md-12 buttons-manage align-items-end" *ngIf="!activeBottomBar">
        <div class="buttons d-flex flex-auto justify-content-end">
          <button class="button gray"
            [popper]="influencerMoreFunctionPopper"
            [popperTrigger]="'click'"
            [popperDisableAnimation]="true"
            [popperApplyClass]="'ngx-popper, grey'"
            [popperApplyArrowClass]="'ngx-popper-arrow'"
            [popperPlacement]="'bottom'">
            {{'common.btn.more' | translate}}
          </button>
          <popper-content #influencerMoreFunctionPopper>
            <ul class="funtion-menu">
              <li>
                <button class="button gray"
                        (click)="exportPdfReport(influencerMoreFunctionPopper)">
                  {{'common.btn.download_as_pdf' | translate}}
                </button>
              </li>
            </ul>
          </popper-content>
          <button class="button blue"
                  actionByLevels="Add to Campaign"
                  [wallName]="'Campaigns Disabled'"
                  [actionData]="invalidActionData(false)"
                  (afterChecking)="showAddToCampaign()">
            {{'common.btn.add_to_compaign' | translate}}
          </button>
          <button class="button green"
                  actionByLevels="Add to Group"
                  [wallName]="'Groups Disabled'"
                  [actionData]="invalidActionData(true)"
                  (afterChecking)="showAddToGroup()">
            {{'common.btn.add_to_group' | translate}}
          </button>
        </div>
      </div>
    <div class="col-md-12 col-sm-12">
      <add-influencer-to-group #AddInfluencerToGroup
                                  *ngIf="isEnableAddToGroup === true"
                                  (addInfluencerToGroupExecution)="addCurrentInfluencerToGroup($event)"
                                  (backToPreviewInfluencerEvent)="hideBottomBar(true)"
                                  (createNewGroupEvent)="openCreateNewGroupFragment($event)"
                                  [pendingAddInfluencerGroup]="pendingAddInfluencerToGroup"
                                  [influencerGroupList]="influencerGroupList" >
      </add-influencer-to-group>
      <add-influencers-to-campaign *ngIf="isEnableAddToCampaign === true"
                                  (addToCampaignExecution)="addInfluencerToCampaign($event)"
                                  (backToPreviewInfluencerEvent)="hideBottomBar()"
                                  [selectedCampaign]="selectedCampaign"
                                  [isUsedToAddPost]="false"
                                  [campaignList]="campaignList">
      </add-influencers-to-campaign>
      <create-group-fragment *ngIf="showCreateNewGroupFragment"
                             [activePage]="activePage"
                             [isShowCreateGroupForm]="showCreateNewGroupFragment"
                             (afterCreateOrUpdateGroupEvent)="afterCreateGroupSuccess($event)"
                             (cancelCreateOrUpdateGroupEvent)="cancelCreateGroup()">
      </create-group-fragment>
    </div>
  </div>
  <div class="full-height" *ngIf="shouldShowActionButtonForCampaign()">
    <div class="d-flex flex-row" *ngIf="!activeBottomBar">
      <div class="d-flex flex-g1 justify-content-start align-items-center">
        <span class="campaign-name">Campaign: {{getActiveCampaignName()}}</span>
      </div>
      <div class="d-flex flex-g1 buttons justify-content-end align-items-center" *ngIf="!hasSelectedPostToDelete">
        <button class="button red" (click)="removeFromCampaignConfirmation()" *ngIf="!isArchivedCampaign">
          {{'INFLUENCER.campaign.btn.remove_from_campaign' | translate}}
        </button>
        <button class="button gray" (click)="openCampaignInReports()">
          {{'INFLUENCER.campaign.btn.open_in_reports' | translate}}
        </button>
        <button class="button blue" (click)="goToCampaignOverview()">
          {{'INFLUENCER.campaign.btn.go_to_overview' | translate}}
        </button>
      </div>
      <div class="d-flex flex-g1 buttons justify-content-end align-items-center" *ngIf="hasSelectedPostToDelete">
        <button class="button red" (click)="confirmBeforeDeleteingPost()">
          {{'INFLUENCER.campaign.btn.delete_posts' | translate}}
        </button>
      </div>
    </div>
  </div>
</div>

<achoo-popup #AlertAddInfluencerToGroupSuccess
             [isNotification]="true"
             modelTitle="{{'notification.success' | translate}}"
             (acceptCallback)="closeModalPopup()"
             (cancelCallback)="closeModalPopup()">
  <div class="d-flex flex-row flex-auto">
    <span>{{addInfluencerToGroupSuccessMessage}}</span>
  </div>
</achoo-popup>

<achoo-popup #AlertAddInfluencerToCampaignSuccess
             [isNotification]="true"
             modelTitle="{{'notification.success' | translate}}"
             (acceptCallback)="closeModalPopup()"
             (cancelCallback)="closeModalPopup()">
  <span>{{'group_details.influencer.add_one_influencer_to_campaign' | translate:{selected_campaign: selectedCampaignNotificationMsg} }}</span>
</achoo-popup>

<achoo-popup #ConfirmRemoveFromCampaign
             [isAlertPopup]="true"
             modelTitle="{{'INFLUENCER.campaign.remove_from_campaign.title' | translate}}"
             acceptBtnLabel="{{'INFLUENCER.campaign.remove_from_campaign.btn_confirm' | translate}}"
             cancelBtnLabel="{{'INFLUENCER.campaign.remove_from_campaign.btn_cancel' | translate}}"
             (acceptCallback)="removeFromCampaign()"
             (cancelCallback)="closeModalPopup()">
  <div [innerHTML]="'INFLUENCER.campaign.remove_from_campaign.message' | translate:{influencerName: influencerName} "></div>
</achoo-popup>

<achoo-popup #ConfirmDeletePostFromCampaign
             [isAlertPopup]="true"
             modelTitle="{{'INFLUENCER.campaign.delete_campaign_post.title' | translate}}"
             acceptBtnLabel="{{'INFLUENCER.campaign.delete_campaign_post.btn_confirm' | translate}}"
             cancelBtnLabel="{{'INFLUENCER.campaign.delete_campaign_post.btn_cancel' | translate}}"
             (acceptCallback)="onDeletePostFromCampaign()"
             (cancelCallback)="closeModalPopup()">
  <div>{{'INFLUENCER.campaign.delete_campaign_post.message' | translate}}</div>
</achoo-popup>

<achoo-popup #AlertPdfDownloadPending
             [isNotification]="true"
             modelTitle="{{'common.alert' | translate}}"
             (acceptCallback)="closeModalPopup()"
             (cancelCallback)="closeModalPopup()">
  <span>{{'pdf.pending_message' | translate}}</span>
</achoo-popup>

<achoo-popup #NotifyPostDeletedSuccess
             [isNotification]="true"
             modelTitle="{{'notification.success' | translate}}"
             (acceptCallback)="closeModalPopup()"
             (cancelCallback)="closeModalPopup()">
  <span>{{'INFLUENCER.campaign.delete_campaign_post.success_msg' | translate}}</span>
</achoo-popup>

<achoo-popup #NotifyPostDeletedError
             [isNotification]="true"
             modelTitle="{{'common.error' | translate}}"
             (acceptCallback)="closeModalPopup()"
             (cancelCallback)="closeModalPopup()">
  <span>{{'INFLUENCER.campaign.delete_campaign_post.error_msg' | translate}}</span>
</achoo-popup>
<achoo-popup #AddInfluencerToCampaignErrorPopup
             [isNotification]="false"
             modelTitle="{{'common.alert' | translate}}"
             [acceptBtnLabel]="'common.btn.ok_thanks' | translate"
             [cancelBtnLabel]="'common.btn.contact_support' | translate"
             (acceptCallback)="closeModalPopup()"
             (cancelCallback)="contactSupport()"
             (closeCallback)="closeModalPopup()">
  <span>{{'discover.add_influencer_to_campaign_error_message' | translate}}</span>
</achoo-popup>
<achoo-popup #AddInfluencerToGroupErrorPopup
             [modelTitle]="'common.alert' | translate"
             acceptBtnLabel="{{'common.btn.ok_close' | translate}}"
             [isAlertPopup]="true"
             (closeCallback)="closeErrorAddingInfluencerAlert()"
             (acceptCallback)="closeErrorAddingInfluencerAlert()">
  <div class="d-flex flex-column flex-auto">
    <span [innerHTML]="'group_details.influencer.add_infl_error_message' | translate"></span>
  </div>
</achoo-popup>
<achoo-popup #NotifyPdfExportError
             [isNotification]="true"
             modelTitle="{{'common.error' | translate}}"
             (acceptCallback)="closeModalPopup()"
             (cancelCallback)="closeModalPopup()">
  <span>{{notifyPdfExportErrorMessage}}</span>
</achoo-popup>



// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer.component.html